'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosCloud = function IoIosCloud(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.7 18.2c3.5 0 6.3 2.9 6.3 6.5 0 3.5-2.9 6.5-6.4 6.5h-21.6c-3.9 0.1-7-3.2-7-7.1 0-3.2 2-5.6 4.8-6.5 0.4-2.2 2.2-4.1 4.6-4.1 0.8 0 1.4 0.2 2 0.5 1.5-3.1 4.6-5.2 8.2-5.2 5 0 9.1 4.1 9.1 9.1 0 0.1 0 0.2 0 0.3z' })
        )
    );
};

exports.default = IoIosCloud;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-cloud.js
// module id = 2359
// module chunks = 0